export function resolveNumericByUuid(valuesMap, uuid, fallback) {
  if (uuid && valuesMap?.[uuid]?.value !== undefined && valuesMap[uuid].value !== null && valuesMap[uuid].value !== '') {
    const num = Number(String(valuesMap[uuid].value).replace(/,/g, ''));
    if (Number.isFinite(num)) {
      return num;
    }
  }

  const fallbackNum = Number(fallback);
  return Number.isFinite(fallbackNum) ? fallbackNum : 0;
}

export function resolveStringByUuid(valuesMap, uuid, fallback) {
  if (uuid && valuesMap?.[uuid]?.value !== undefined && valuesMap[uuid].value !== null && String(valuesMap[uuid].value).trim() !== '') {
    return String(valuesMap[uuid].value);
  }

  return fallback ?? '';
}

export function resolveInputNumberPrefixText({
  prefix,
  prefixUuid,
  valuesMap,
  defaultCurrencySymbol = '',
}) {
  const normalizedPrefix = String(prefix || 'none').trim();

  if (normalizedPrefix === 'uuid') {
    const raw = resolveStringByUuid(valuesMap, prefixUuid, '');
    const resolved = resolveCurrencySymbolText(raw);
    // Currency symbol fields often default to numeric 0 before a currency is chosen.
    if (resolved === '0') {
      return '';
    }
    return resolved;
  }

  if (normalizedPrefix === 'currency') {
    return resolveCurrencySymbolText(defaultCurrencySymbol);
  }

  if (normalizedPrefix === 'none' || normalizedPrefix === '%') {
    return normalizedPrefix;
  }

  return normalizedPrefix;
}

export function resolveCurrencySymbolText(raw) {
  if (raw === undefined || raw === null) {
    return '';
  }

  const str = String(raw).trim();
  if (!str) {
    return '';
  }

  if (!str.includes('<') && !str.includes('&')) {
    return str;
  }

  if (typeof document !== 'undefined') {
    const el = document.createElement('div');
    el.innerHTML = str;
    return (el.textContent || el.innerText || str).trim();
  }

  return str.replace(/<[^>]*>/g, '').trim();
}

export function resolveProjectionCurrencySymbol({
  valuesMap,
  currencySymbolUuid,
  staticSymbol,
  defaultSymbol,
}) {
  const fromUuid = currencySymbolUuid
    ? resolveCurrencySymbolText(resolveStringByUuid(valuesMap, currencySymbolUuid, ''))
    : '';

  if (fromUuid) {
    return fromUuid;
  }

  if (staticSymbol) {
    return resolveCurrencySymbolText(staticSymbol);
  }

  return resolveCurrencySymbolText(defaultSymbol) || '£';
}
